import { render, staticRenderFns } from "./DepositModal.vue?vue&type=template&id=4897e9d7"
import script from "./DepositModal.vue?vue&type=script&lang=js"
export * from "./DepositModal.vue?vue&type=script&lang=js"
import style0 from "./DepositModal.vue?vue&type=style&index=0&id=4897e9d7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports